import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  standalone: false,
  selector: 'app-modal-popup-alert',
  templateUrl: './modal-popup-alert.component.html',
  styleUrls: ['./modal-popup-alert.component.css']
})
export class ModalPopupAlertComponent {
  @Input() strText: any;
  constructor(public activeModal: NgbActiveModal) { }

  closeModal() {
    this.activeModal.close("close");
  }

}
